import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'

import { FootPrintPortalManager_shipping_orders_gridComponent } from './FootPrintPortalManager.shipping_orders_grid.component';
import { FootPrintPortalManager_shipping_orders_by_tracking_gridComponent } from './FootPrintPortalManager.shipping_orders_by_tracking_grid.component';
import { SalesOrders_order_total_picked_order_count_by_date_widgetComponent } from './SalesOrders.order_total_picked_order_count_by_date_widget.component';
import { SalesOrders_order_total_completed_order_count_by_date_widgetComponent } from './SalesOrders.order_total_completed_order_count_by_date_widget.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Locations_warehouses_dd_multiComponent } from './Locations.warehouses_dd_multi.component'
import { PurchaseOrders_orderstatuses_dd_multiComponent } from './PurchaseOrders.orderstatuses_dd_multi.component'
import { Materials_materials_by_project_dd_multiComponent } from './Materials.materials_by_project_dd_multi.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootPrintPortalManager_shipping_orders_gridComponent),
    forwardRef(() => FootPrintPortalManager_shipping_orders_by_tracking_gridComponent),
    forwardRef(() => SalesOrders_order_total_picked_order_count_by_date_widgetComponent),
    forwardRef(() => SalesOrders_order_total_completed_order_count_by_date_widgetComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Locations_warehouses_dd_multiComponent),
    forwardRef(() => PurchaseOrders_orderstatuses_dd_multiComponent),
    forwardRef(() => Materials_materials_by_project_dd_multiComponent),
  ],
  selector: 'FootPrintPortalManager-shipping_orders_hub',
  templateUrl: './FootPrintPortalManager.shipping_orders_hub.component.html'
})
export class FootPrintPortalManager_shipping_orders_hubComponent implements OnInit, OnDestroy {


  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { currentDate?: string, calendar_viewDate?: string, calendar_dockDoorIds?: number[], defaultWarehouseId?: number } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    warehouse: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    materials: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    reference: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    ship_to_search: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create_shipping_order: new ToolModel(new ButtonModel('create_shipping_order', new ButtonStyles(null, null), false, 'Create shipping order', 'ms-Icon ms-Icon--Add')
    ),
      import_orders: new ToolModel(new ButtonModel('import_orders', new ButtonStyles(null, null), false, 'Import orders', 'ms-Icon ms-Icon--ExcelDocument')
    ),
      manage_ship_to_contacts: new ToolModel(new ButtonModel('manage_ship_to_contacts', new ButtonStyles(null, null), false, 'Manage ship to contacts', 'ms-Icon ms-Icon--SettingsAdd')
    )
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Owner', true)
,
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Project', false)
,
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Warehouses', false)
,
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Status', false)
,
    materials: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['materials'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Materials', false)
,
    reference: new FieldModel(new TextBoxModel(this.formGroup.controls['reference'] as DatexFormControl, null, false, '')
, new ControlContainerStyles(null, null), 'Vendor/Owner reference', false)
,
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, '', 'date')
, new ControlContainerStyles(null, null), 'Created from', false)
,
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, '', 'date')
, new ControlContainerStyles(null, null), 'Created to', false)
,
    ship_to_search: new FieldModel(new TextBoxModel(this.formGroup.controls['ship_to_search'] as DatexFormControl, null, false, '')
, new ControlContainerStyles(null, null), 'Ship to search', false)
,
  };


  filtersets = {
  newGroup1: new FieldsetModel('Filters', false, true, false),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
      shipping_orders: new TabGroupModel(),
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      shipping_orders: new TabItemModel(
        this.rootTabGroup, 
        'Shipping orders', 
        true,
        {
          shipping_orders: new TabItemModel(
          this.subTabGroups.shipping_orders, 
          'Shipping orders', 
          ),
          shipping_orders_tracking: new TabItemModel(
          this.subTabGroups.shipping_orders, 
          'Tracking numbers', 
          ),
        }
        ),
    };
  
    //#region tabs inParams
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId: number[];
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds: number[];
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.status.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds;
    }
  
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_reference(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.reference.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds: number[];
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds;
    }
  
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_fromDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.date_from.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_toDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.date_to.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_ship_to_search(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.ship_to_search.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId: number[];
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds: number[];
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.status.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_reference(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.reference.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds: number[];
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_fromDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.date_from.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_toDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.date_to.control.value;
      
      return expr;
    }
  
    get $tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_ship_to_search(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.ship_to_search.control.value;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
        @ViewChild('$tabs_shipping_orders_shipping_orders', { read: FootPrintPortalManager_shipping_orders_gridComponent }) $tabs_shipping_orders_shipping_orders: FootPrintPortalManager_shipping_orders_gridComponent;
        @ViewChild('$tabs_shipping_orders_shipping_orders_tracking', { read: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent }) $tabs_shipping_orders_shipping_orders_tracking: FootPrintPortalManager_shipping_orders_by_tracking_gridComponent;
    //#endregion tabs children
    widgets = {
      order_total_picked_order_count_by_date_widget: new WidgetModel(),
      order_total_completed_order_count_by_date_wdiget: new WidgetModel(),
    };
  
    //#region widgets inParams
    get $widgets_order_total_picked_order_count_by_date_widget_inParams_date(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.vars.currentDate;
      
      return expr;
    }
  
    get $widgets_order_total_picked_order_count_by_date_widget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_order_total_picked_order_count_by_date_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId: number[];
    get $widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId, expr)) {
        this.cacheValueFor_$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId = expr;
      }
      return this.cacheValueFor_$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId;
    }
  
    get $widgets_order_total_completed_order_count_by_date_wdiget_inParams_date(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.vars.currentDate;
      
      return expr;
    }
  
    get $widgets_order_total_completed_order_count_by_date_wdiget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_order_total_completed_order_count_by_date_wdiget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId: number[];
    get $widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId, expr)) {
        this.cacheValueFor_$widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId = expr;
      }
      return this.cacheValueFor_$widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_order_total_picked_order_count_by_date_widget', { read:  SalesOrders_order_total_picked_order_count_by_date_widgetComponent }) $widgets_order_total_picked_order_count_by_date_widget: SalesOrders_order_total_picked_order_count_by_date_widgetComponent;
      @ViewChild('$widgets_order_total_completed_order_count_by_date_wdiget', { read:  SalesOrders_order_total_completed_order_count_by_date_widgetComponent }) $widgets_order_total_completed_order_count_by_date_wdiget: SalesOrders_order_total_completed_order_count_by_date_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  cacheValueFor_$fields_status_selector_inParams_statusIds: number[];
  get $fields_status_selector_inParams_statusIds(): number[] {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = [1,2,4,8,128];
    
    if(!isEqual(this.cacheValueFor_$fields_status_selector_inParams_statusIds, expr)) {
      this.cacheValueFor_$fields_status_selector_inParams_statusIds = expr;
    }
    return this.cacheValueFor_$fields_status_selector_inParams_statusIds;
  }



  get $fields_materials_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Shipping Orders hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Your landing page to view shipping orders across your projects and assigned warehouses.`;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: FootPrintPortalManager_ShellService,
  private datasources: FootPrintPortalManager_DatasourceService,
  private flows: FootPrintPortalManager_FlowService,
  private reports: FootPrintPortalManager_ReportService,
  private localization: FootPrintPortalManager_LocalizationService,
  private operations: FootPrintPortalManager_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.shipping_orders,
    ]; 
    this.subTabGroups.shipping_orders.tabs = [
        this.tabs.shipping_orders.tabs.shipping_orders,
        this.tabs.shipping_orders.tabs.shipping_orders_tracking,
    ];    
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Shipping Orders Hub';
    
    const $hub = this;
    const $utils = this.utils;

    (this.filters.status.control as SelectBoxModel).reset([1,2,128]);
    
    

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_order_total_picked_order_count_by_date_widget') {
      if (!isNil(this.$widgets_order_total_picked_order_count_by_date_widget) && !this.widgets.order_total_picked_order_count_by_date_widget.hidden) {
        this.$widgets_order_total_picked_order_count_by_date_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_order_total_completed_order_count_by_date_wdiget') {
      if (!isNil(this.$widgets_order_total_completed_order_count_by_date_wdiget) && !this.widgets.order_total_completed_order_count_by_date_wdiget.hidden) {
        this.$widgets_order_total_completed_order_count_by_date_wdiget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
      if (childToSkip !== '$tabs_shipping_orders_shipping_orders') {
        if (!isNil(this.$tabs_shipping_orders_shipping_orders) && !this.tabs.shipping_orders.tabs.shipping_orders.hidden) {
          this.$tabs_shipping_orders_shipping_orders.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_shipping_orders_shipping_orders_tracking') {
        if (!isNil(this.$tabs_shipping_orders_shipping_orders_tracking) && !this.tabs.shipping_orders.tabs.shipping_orders_tracking.hidden) {
          this.$tabs_shipping_orders_shipping_orders_tracking.refresh(true, false, null);
        }
      }   
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_create_shipping_order_clicked(event = null) {
    return this.on_create_shipping_order_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_shipping_order_clickedInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  // Initialize the first warehouse selected
  var warehouseId = null;
  
  if ($utils.isDefined($hub.filters.warehouse.control.value)) {
      warehouseId = $hub.filters.warehouse.control.value[0];
  };
  
  
   const dialogResult = (await $shell.FootPrintPortalManager.openshipping_order_creation_form({
       ownerId: $hub.filters.owner.control.value,
       projectId: $hub.filters.project.control.value,
       warehouseId: $utils.isDefined(warehouseId) ? warehouseId : null
       }));
  
  }
  on_import_orders_clicked(event = null) {
    return this.on_import_orders_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_import_orders_clickedInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  if ($utils.isAllDefined($hub.filters.project.control.value, $hub.filters.warehouse.control.value)) {
      await $shell.ExcelOrderImport.openexcel_portal_order_import_gridDialog({
          projectId: $hub.filters.project.control.value,
          warehouseId: $hub.filters.warehouse.control.value
      });
  
      $hub.refresh();
  
  }
  else {
      $shell.FootPrintPortalManager.openInfoDialog('Import Orders', 'Please first select a project and warehouse.')
  }
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($hub.filters.owner.control.value)) {
  
      $hub.widgets.order_total_picked_order_count_by_date_widget.hidden = false;
  
  }
  else {
      $hub.widgets.order_total_picked_order_count_by_date_widget.hidden = true;
  
  }
  
  $hub.filters.project.control.value = null;
  $hub.filters.materials.control.value = null;
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const projectId = $hub.filters.project.control.value
  
  if ($utils.isDefined(projectId)) {
      $hub.filters.materials.control.value = null;
  }
  
  // Set Owner from Project
  if ($utils.isDefined(projectId) && !$utils.isDefined($hub.filters.owner.control.value)) {
      const project = (await $datasources.Materials.ds_get_project_by_projectId.get({
          projectId: projectId
      })).result;
     
      if ($utils.isDefined(project)) {
  
          $hub.filters.owner.control.value = project[0].OwnerId;
  
      }
  
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply operations
  if (await $operations.FootPrintPortalManager.Disable_Shipping_Orders_Hub.isAuthorized()){
      $hub.close();
      $shell.FootPrintPortalManager.openErrorDialog('Authorization','You are not authorized to access the shipping orders hub.');
      
  }
  
  
  
  $hub.vars.currentDate = $utils.date.now();
  // Set Date/Time Formats
  const format = `${$settings.FootPrintPortalManager.DateFormat}, ${$settings.FootPrintPortalManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  // Apply date format
  $hub.filters.date_from.control.format = format;
  $hub.filters.date_to.control.format = format;
  
  //Initially hide the widgets, we only want them to show when at least an owner is selected
  $hub.widgets.order_total_picked_order_count_by_date_widget.hidden = true;
  
  // Default to the first owner and project based on the users data access role
  const project = (await $datasources.Owners.ds_get_project_top1.get({})).result;
  if ($utils.isDefined(project)) {
  
      const projectId = project.Id;
      const ownerId = project.OwnerId;
  
      if ($utils.isAllDefined(projectId, ownerId)) {
          $hub.filters.project.control.value = projectId;
          $hub.filters.owner.control.value = ownerId;
  
          $hub.widgets.order_total_picked_order_count_by_date_widget.hidden = false;
      }
  }
  
  // Default to the first warehouse based on the users data access role
  const warehouse = (await $datasources.Locations.ds_get_warehouse_top1.get({})).result;
  if ($utils.isDefined(warehouse)) {
  
      const warehouseId = warehouse.Id;
  
      if ($utils.isDefined(warehouseId)) {
          $hub.filters.warehouse.control.value = [warehouseId];
      }
  
  }
  
  // Apply operations
  
  if (await $operations.FootPrintPortalManager.Disable_OrdersHub_CreateShippingOrder.isAuthorized()) {
      $hub.toolbar.create_shipping_order.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_OrdersHub_ImportOrders.isAuthorized()) {
      $hub.toolbar.import_orders.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_OrdersHub_ManageShipToContacts.isAuthorized()) {
      $hub.toolbar.manage_ship_to_contacts.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_OrdersHub_ShippingOrders.isAuthorized()) {
      $hub.tabs.shipping_orders.hidden = true;
      $hub.widgets.order_total_picked_order_count_by_date_widget.hidden = true;
  }
  }
  on_manage_ship_to_contacts(event = null) {
    return this.on_manage_ship_to_contactsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_manage_ship_to_contactsInternal(
    $hub: FootPrintPortalManager_shipping_orders_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($hub.filters.owner.control.value)) {
      await $shell.FootPrintPortalManager.openownersaccounts_gridDialog({
          ownerId: $hub.filters.owner.control.value,
          typeIds: [2, 3, 4, 5],
          accountTypeId: 2,
          allowSelection: false
      });
  
  }
  else {
      $shell.FootPrintPortalManager.openInfoDialog('Manage ship to contacts', 'Please select an owner filter first.')
  }
  }
  //#endregion private flows
}
